
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Wait } from '@/__env/ext';
    import moment,{ Moment } from 'moment';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Articulo: Articulo;
        @Prop() public Seleccionado: boolean;
        @Watch( 'Seleccionado', { immediate: true } )
        async onSeleccionado()
        {
            if ( !this.Articulo )
                return;

            if ( !this.Seleccionado )
                return;

            this.Cargando = true;

            this.Observacion = '';
            this.UltimaModificacion = null;

            if ( !this.Articulo )
                return;

            await Wait( 300 );
            let e = await this.Articulo.CargarObservacion();
            if ( e )
            {
                this.UltimaModificacion = e.Fecha;
                this.Observacion = e.Observacion;
            }

            this.$nextTick( () =>
            {
                this.Cargando = false;
            } );
        }

        public UltimaModificacion: Moment = null;
        public Cargando: boolean = false;
        public Guardando: boolean = false;
        public Error: boolean = false;

        public Observacion: string = '';
        @Watch( 'Observacion' )
        async onObservacion()
        {
            if ( this.Cargando )
                return;

            let bb = this.Observacion;
            this.Error = false;
            await Wait( 600 );
            if ( bb == this.Observacion )
            {
                await this.Guardar();


            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }



        async Guardar()
        {
            this.Guardando = true;
            let e = await this.Articulo.GuardarObservacion( this.Observacion );
            if ( e )
            {
                this.UltimaModificacion = moment();
            } else
            {
                this.Error = true;
            }
            this.Guardando = false;
        }

    }
